export default "__VITE_ASSET__c2b52afb__"